import {API_HOST,API_HOST_FZK,API_HOST_DPC} from "@/config/index";

let fzk_websocket = '';
let archive_websocket = '';
if (process.env.NODE_ENV === 'development') {
  fzk_websocket = 'http://192.168.10.52:2000'
  archive_websocket = 'http://192.168.10.52:177'
} else {
  fzk_websocket = API_HOST_FZK  + '/zhFzkBackstage'
  archive_websocket = 'http://yhylhthome.yhylht.cn'
}


export const fzk_socket_url = {
  // 发起socket  链接
  webSocket: fzk_websocket +'/ws/fzkBackstage',
  // 订阅版本更新
  versionApi: '' + '/topic/versionUpdate/fzk/3',
  contentManageChange:  '/topic/contentManage/all',
};


export const archive_socket_url = {
  // 发起socket  链接
  webSocket: archive_websocket + '/zhArchivesBackstage/ws/endpointChat',
  // 订阅版本更新
  getListLeaveByToday: '' + '/topic/ws/goOutsideListByToday',
  getListFreedomByToday: '' + '/topic/ws/goOutsideFreedomListByToday',
  // 订阅内容变更通知
};




// WEBPACK FOOTER //
// ./src/api/uri/socket.js